<template>
	<v-main>
		<v-navigation-drawer fixed clipped permanent style="padding: 64px 0px 0px 0px;"
			width="300"
		>
			<v-card flat>
				<v-card-text>
					<v-form ref="form">
						<v-row dense>
							<v-col cols="12">

								<!-- <z-vehicle-number-vin
									v-model="params.numbervin"
									outlined
									dense
									clearable
									:rules="rules"
									default-vin="WVGZZZCRZKD026937"
								></z-vehicle-number-vin> -->
							</v-col>
							<v-col cols="12">
								<v-text-field
									label="VIN-код"
									v-model="vin"
									outlined
									dense
									hide-details="auto"
									min="0"
									@keyup.ctrl.90="vin='WVGZZZCRZKD026937'"
								></v-text-field>
								<!-- @keyup.ctrl.90="$set(params, 'odometer', 150000)" -->
							</v-col>
						</v-row>
					</v-form>
				</v-card-text>
			</v-card>
			<template v-slot:append>
				<v-card-actions class="px-4">
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="onClear">{{ $vuetify.lang.t('$vuetify.clear') }}</v-btn>
					<v-btn color="primary" @click="onOK">{{ $vuetify.lang.t('$vuetify.ok') }}</v-btn>
				</v-card-actions>
			</template>
		</v-navigation-drawer>

		<v-navigation-drawer fixed clipped permanent right
			mini-variant
			mini-variant-width="56"
			style="padding: 64px 0px 0px 0px;"
        >
			<v-list dense nav>
				<!-- Favorit -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon v-if="isFavorit" color="yellow-darken-1" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star</v-icon>
            					<v-icon v-else class="opacity-30" v-bind="attrs" v-on="{ ...tooltip }" @click="onFavorit">mdi-star-outline</v-icon>
							</template>
							<span>Вибране</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>
				<!-- PDF -->
				<v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on: tooltip, attrs }">
								<v-icon color="red" v-bind="attrs" v-on="{ ...tooltip }" @click="onPDF">mdi-file-pdf-box</v-icon>
							</template>
							<span>Експорт PDF</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item>

				<!-- Excel -->
				<!-- <v-list-item>
					<v-list-item-action>
						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<z-excel
									:name="excelName"
									:type="excel.type"
									:fields="excel.fields"
									:data="excelData"
								>
									<v-icon color="green darken-2" :disabled="excel.disabled" v-bind="attrs" v-on="on">mdi-microsoft-excel</v-icon>
								</z-excel>
							</template>
							<span>Експорт Excel</span>
						</v-tooltip>
					</v-list-item-action>
				</v-list-item> -->
				<v-divider></v-divider>
			</v-list>
        </v-navigation-drawer>

		<v-container style="padding: 64px 0px 0px 300px;">
			<v-card flat>
				<v-card-title class="font-weight-light">
					{{ title }} <!-- {{ id ? '№' + id: '' }} -->
				</v-card-title>

				<v-divider></v-divider>
				
				<v-card flat>
					<!-- <v-card-title v-if="parameters.length">Параметри</v-card-title> -->
					<v-card-title>Параметри</v-card-title>
					<v-card-text>
						<v-data-table
							:headers="headers"
							:items="parameters"
							:items-per-page="-1"
						>
							<template v-slot:top>
								<v-switch
									v-model="isValue"
									label="Тільки зі значеннями"
									class="pa-3"
								></v-switch>
							</template>
						</v-data-table>
						<!-- <v-simple-table dense>
							<template v-slot:default>
								<tbody>
									<tr v-for="(item, index) in items" :key="index">
										<td>{{ item.VariableId }}</td>
										<td>{{ item.Variable }}</td>
										<td>{{ item.ValueId }}</td>
										<td>{{ item.Value }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table> -->
					</v-card-text>
				</v-card>

				<!-- <v-banner two-line v-if="bannerNoModelVisible">
					<v-avatar slot="icon" size="40">
						<v-icon icon="mdi-alert" color="warning">mdi-alert</v-icon>
					</v-avatar>
					<div>Увага! Не визначено модель транспортного засобу.</div>
					<div>Розрахунок здійснюється без врахування моделі.</div>
					<div>Більш точну оцінку можна зробити за допомогою розширеного набору параметрів.</div>
					<template v-slot:actions>
						<v-btn text color="primary" @click="onLink">
							Перейти
						</v-btn>
					</template>
				</v-banner>

				<v-card flat v-for="(estimate, index) in estimates" :key="index">
					<v-card-title>{{ estimate.name }}</v-card-title>

					<v-card-text>
						<v-simple-table dense>
							<template v-slot:default>
								<tbody>
									<tr>
										<td width="50%">UAH</td>
										<td>{{ estimate.avgPriceUAH | toMoney }}</td>
									</tr>
									<tr>
										<td>USD</td>
										<td>{{ estimate.avgPriceUSD | toMoney }}</td>
									</tr>
								</tbody>
							</template>
						</v-simple-table>
					</v-card-text>
				</v-card>

				<v-banner two-line v-if="bannerNoDataVisible">
					<v-avatar slot="icon" size="40">
						<v-icon icon="mdi-alert" color="warning">mdi-alert</v-icon>
					</v-avatar>
					<div>Транспортний засіб в єдиному державному реєстрі не знайдено.</div>
					<div>Спробуйте зробити оцінку за допомогою параметрів.</div>
					<template v-slot:actions>
						<v-btn text color="primary" @click="onLink">
							Перейти
						</v-btn>
					</template>
				</v-banner>

				<v-banner two-line v-if="bannerEstimateVisible">
					<v-avatar slot="icon" size="40">
						<v-icon icon="mdi-alert" color="warning">mdi-alert</v-icon>
					</v-avatar>
					<div>Причиною відсутності результату може бути невідповідність параметрів, за якими проводиться оцінка, значенням в довідниках системи.</div>
					<div>Спробуйте зробити оцінку за допомогою параметрів.</div>
					<template v-slot:actions>
						<v-btn text color="primary" @click="onLink">
							Перейти
						</v-btn>
					</template>
				</v-banner> -->
			</v-card>
		</v-container>
		<v-overlay :value="loading">
			<v-progress-circular indeterminate size="64"></v-progress-circular>
		</v-overlay>
		<v-snackbar v-model="snackbar.visible" :color="snackbar.color">
			{{ snackbar.text }}
			<template v-slot:action="{ attrs }">
			<v-btn icon v-bind="attrs" @click="snackbar.visible = false" >
				<v-icon>mdi-close</v-icon>
			</v-btn>
			</template>
		</v-snackbar>

		<z-pdf ref="pdf" :item="item"></z-pdf>
	</v-main>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
import mixin from './mixin/parameters'
import zExcel from "vue-json-excel";
import zPdf from '@/views/pdf/VehicleEstimateExpress'
import zVehicleNumberVin from '@/views/components/control/VehicleNumberVin'

export default {
	name: 'VehicleEstimateExpress',
	mixins: [mixin],
	components: {
		zPdf,
		zExcel,
		zVehicleNumberVin,
	},
	data: () => ({
		title: 'VIN Decoder',
		loading: false,

		vin: null,
		items: [],
		headers: [
			//{ text: 'ID', value: 'id', align: ' d-none' },
			{ text: 'ID', value: 'VariableId', sortable: true},
			{ text: 'Назва', value: 'Variable', sortable: true},
			//{ text: 'ValueId', value: 'ValueId', sortable: true},
			{ text: 'Значення', value: 'Value', sortable: true},
			//{ text: '', value: 'actions', sortable: false, width: '10%' },
		],

		isValue: true,

		bannerNoDataVisible: false,

		excel: {
			name: '',
			type: 'xlsx',
			//type: 'csv',
			disabled: false,
			data: [],
			fields: {
				"Complete name": "name",
				Value: "value",
			},
			meta: [
				[
					{ key: "charset", value: "utf-8" },
				],
			],
		},

		snackbar: {
			visible: false,
			text: null,
			color: null
		},
	}),
	
	computed: {
		...mapGetters('VehicleEstimateExpress', [ 'item', 'id', 'parameters', 'estimates' ]),
	
		excelName() {
			return `${this.title} ${this.id}.${this.excel.type}` 
		},

		parameters() {
			const parameters = this.isValue ? this.items.filter(item => item.Value !== null && item.Value !== '') : this.items;
			return parameters
		},
		

		/* excelData() {
			let data = []

			data.push({ name: 'Параметри' })

			this.parameters.forEach(item => {
				data.push({ name: item.name, value: item.value })
			})

			this.estimates.forEach(estimate => {
				data.push({ name: estimate.name })
				data.push({ name: 'UAH', value: estimate.avgPriceUAH })
				data.push({ name: 'USD', value: estimate.avgPriceUSD })
			})

			
			//console.log(this.$options.name, 'excelData','data', data)

			return data;
		},

		favorit() {
			return this.favorits.find(element => element.id === this.id);
		},

		bannerEstimateVisible() {
			let result = false

			if(this.estimates.length) {
				this.estimates.forEach(estimate => {
					result = result || !(estimate.avgPriceUAH > 0 || estimate.avgPriceUSD > 0)
				})
			} 
			
			//console.log(this.$options.name, 'bannerVisible','result', result)

			return result
		},

		bannerNoModelVisible() {
			//console.log(this.$options.name, 'bannerNoModelVisible', 'parameters', this.parameters)

			let model = this.parameters.find(element => element.code == 'model')

			return  this.id && !model
		}, */
	},

	methods: {
		...mapActions('VehicleEstimateExpress', [ 'setItem' ]),

		onClear() {
			this.$refs.form.reset()
		},

		onOK() {

			//const decoder = await createDecoder();
			//const result = await decoder.decode("KM8K2CAB4PU001140");
			/* const decoder = createDecoder();
			const result = decoder.decode("KM8K2CAB4PU001140");

			console.log(result.components.vehicle); */
			// { make: 'Hyundai', model: 'Kona', year: 2023, ... }

			//await decoder.close();

			//console.log(that.$options.name, 'onOK', 'params', this.params)
			/* this.bannerNoDataVisible = false

			if(this.$refs.form.validate()) {
				this.loading = true
				var that = this

				that.setItem()

				axios.post('/vehicle/estimate/express', this.params).then(response => {
					//console.log(that.$options.name, 'onOK','response.data', response.data)
					
					that.setItem(response.data)
				}, error => {
					//console.log('error', error)
					//console.log('error.response', error.response)

					if(error.response.status == 404) {
						that.bannerNoDataVisible = true
					} else {
						that.snackbar.visible 	= true;
						that.snackbar.text 		= error.response.data.message;
						that.snackbar.color 	= null;
					}
				}).finally(() => {
					this.loading = false
				});
			} */

			/* https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${vin}?format=json
			https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/WVGZZZCRZKD026937?format=json */

			if(this.$refs.form.validate()) {
				this.loading = true
				var that = this
				axios.get(`https://vpic.nhtsa.dot.gov/api/vehicles/decodevin/${this.vin}?format=json`).then(response => {
					console.log(that.$options.name, 'onOK','response.data', response.data)
					
					const Count =  response.data?.Count;
					const Message =  response.data?.Message;
					const Results =  response.data?.Results;
					const SearchCriteria =  response.data?.SearchCriteria;

					this.items = Results
					//that.setItem(response.data)
				}, error => {
					console.log('error', error)
					//console.log('error.response', error.response)

					/* if(error.response.status == 404) {
						that.bannerNoDataVisible = true
					} else {
						that.snackbar.visible 	= true;
						that.snackbar.text 		= error.response.data.message;
						that.snackbar.color 	= null;
					} */
				}).finally(() => {
					this.loading = false
				});
			}
		},

		onFavorit() {
			//console.log(this.$options.name, 'onFavorit','favorit', this.favorit)

			if(this.id) {
				if(this.favorit) {
					this.removeFavorit(this.favorit) 
				} else {
					//console.log(this.$options.name, 'onFavorit','item', this.item)

					let number = this.item.number;
					let vin = this.item.vin;

					let code = `${this.$options.name}:${number?number:''}:${vin?vin:''}`
					let name = number?number:(vin?vin:'ТЗ')

					let favorit = {
						id: this.item.id,
						code: code,
						name: name,
						number: number,
						vin: vin,
						category: this.item.category,
						brand: this.item.brand, 
						model: this.item.model,
						//color: this.item.color,
						fuel: this.item.fuel,
						yearProd: this.item.yearProd,
						yearProdFrom: this.item.yearProd,
						yearProdTo: this.item.yearProd,
						engineVolume: this.item.engineVolume,
						//engineVolume: isNaN(this.item.engineVolume) ? null : this.item.engineVolume / 1000,
						//engineVolumeFrom: isNaN(this.item.engineVolume) ? null : Math.floor(this.item.engineVolume / 1000),
						//engineVolumeTo: isNaN(this.item.engineVolume) ? null : Math.ceil(this.item.engineVolume / 1000),
					}

					//console.log(this.$options.name, 'onFavorit','favorit', favorit)

					this.addFavorit(favorit)
				}
			}
		},

		onPDF () {
			this.$refs.pdf.generate()
		},

		onLink() {
			//console.log(this.$options.name, 'onLink', 'item', this.item)

			if(!this.favorit) {
				this.onFavorit()
			}

			this.$router.push({name: 'VehicleAveragePriceCombo'})
		}
	},
}
</script>